import type { ReactNode } from 'react';

import { Button } from '@/ui/button/Button';

/** Solid brand team-dialog footer button (Create team / primary actions). */
export function ModalPrimaryButton({
  children,
  isLoading,
  iconRight,
  ...props
}: Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className'> & { isLoading?: boolean; iconRight?: ReactNode }) {
  return (
    <Button type="button" variant="primary" size={8} isLoading={isLoading} iconRight={iconRight} {...props}>
      {children}
    </Button>
  );
}
